var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0834 15.75L15.5001 13.1667C14.9167 14.0833 14.0834 14.9167 13.1667 15.5L15.7501 18.0833C16.0834 18.4167 16.5834 18.4167 16.9167 18.0833L18.0834 16.9167C18.4167 16.5833 18.4167 16.0833 18.0834 15.75Z",
    fill: "#5D78FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.16675 16.6667C5.00008 16.6667 1.66675 13.3333 1.66675 9.16667C1.66675 5 5.00008 1.66667 9.16675 1.66667C13.3334 1.66667 16.6667 5 16.6667 9.16667C16.6667 13.3333 13.3334 16.6667 9.16675 16.6667ZM9.16675 3.33333C5.91675 3.33333 3.33341 5.91667 3.33341 9.16667C3.33341 12.4167 5.91675 15 9.16675 15C12.4167 15 15.0001 12.4167 15.0001 9.16667C15.0001 5.91667 12.4167 3.33333 9.16675 3.33333ZM6.66675 9.16667C6.66675 7.75 7.75008 6.66667 9.16675 6.66667C9.66675 6.66667 10.0001 6.33333 10.0001 5.83333C10.0001 5.33333 9.66675 5 9.16675 5C6.83341 5 5.00008 6.83333 5.00008 9.16667C5.00008 9.66667 5.33341 10 5.83341 10C6.33341 10 6.66675 9.66667 6.66675 9.16667Z",
    fill: "#5D78FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.dc147924b26545863fd3550ed91de0a9.svg";
export { ForwardRef as ReactComponent };